import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { Team } from '../../_shared/models/team.model';
import { Tie } from '../../_shared/models/tie.model';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-sub-player',
  templateUrl: './sub-player.component.html',
  styleUrls: ['./sub-player.component.scss'],
  standalone: true,
  imports: [
    IonicModule, 
    CommonModule, 
    FormsModule
    ]
})
export class SubPlayerComponent  implements OnInit {
    @Input({required: false}) player: any;
    @Input({required: false}) team: Team;
    @Input({required: false}) tie: Tie;
    @Input({required: false}) matchType: string;
    @Input({required: false}) sideNumber: number;
    @Output() playerSelectedId = new EventEmitter<{ selectedPlayerId: any, playerNumber: number, checked: boolean, playerInfo: any }>();

    public selectedPlayerId: string | null = null;

    constructor() { }

    ngOnInit() {
        // Automatically select the first player when matchType === 'S'
        if (this.matchType?.toLowerCase() === 's' && this.player?.length > 0) {
            this.selectedPlayerId = this.player[0]?.person?._id;
        }
    }

    trackById(index: number, item: any): string {
        return item._id;
    }

    getPlayerId(playerInfo: any): void {
        if (this.selectedPlayerId === playerInfo.person._id) {
            this.selectedPlayerId = null;
            this.playerSelectedId.emit({ selectedPlayerId: null, playerNumber:  playerInfo?.playerNumber, checked: false, playerInfo: playerInfo });
        } else {
            this.selectedPlayerId = playerInfo.person._id;
            this.playerSelectedId.emit({ selectedPlayerId: this.selectedPlayerId, 
                playerNumber: playerInfo?.playerNumber, 
                checked: true,
            playerInfo: playerInfo });
        }
    }
}
